import React, { useState, useEffect } from 'react';
import Select from 'react-select'
import { MetadataService } from './../../service/metadata.service'
import { ApplicationService } from './../../service/application.service'
import Popup from 'reactjs-popup';
import Alert from '../common/Alert';

import '../../../node_modules/reactjs-popup/dist/index.css';

const RegionCountry = (params) => {
    const metadataService = new MetadataService();
    const applicationService = new ApplicationService();

    const [regionId, setRegionId] = useState(0);
    const [regions, setRegions] = useState([]);
    const [countries, setCountries] = useState([]);
    const [appCountries, setAppCountries] = useState([]);
    const [message, setMessage] = useState('');
    const [alertOn, setAlertOn] = useState(false);


    useEffect(() => {
        const fetchData = async () => {
            try {
                if (!params.id || params.id === 0) {
                    setMessage("Application is not saved yet, please save the application first.");
                }

                setRegions(params.appRegions);

                const rsCountry = await metadataService.getCountries();
                let dtCountry = rsCountry.data.map(function (a) {
                    return { value: a.id, label: (a.name) };
                });
                setCountries(dtCountry);
            } catch (error) {
                console.error(error);
            }
        };

        fetchData();
    }, []);

    const handleChange = (e) => {
        setAppCountries(e);
    };

    const alertOff = () => {
        setAlertOn(false);
        params.onClose();
    };


    const loadCountries = async (e) => {
        setRegionId(e.value);
        const rsRegCountry = await applicationService.getApplicationRegionCountry(params.id, e.value);
        let countryIds = rsRegCountry.data.map(function (a) {
            return a.countryId;
        });

        let appCntry = countries.filter((c) => {
            return countryIds.includes(c.value);
        });
        setAppCountries(appCntry);
    };

    const saveRegionCountries = async () => {
        let countryIds = appCountries.map(function (a) {
            return a.value;
        });

        if (params.id > 0 && regionId > 0 && countryIds.length > 0) {
            let rsSave = await applicationService.saveApplicationWiseCountriesInRegion(params.id, regionId, countryIds)
            if (rsSave.status === 200) {
                setAlertOn(true);
            }
        }
        else {
            alert("Not all values are properly selected.");
        }
    }

    return (
        <>
            {alertOn && (
                <Alert type="success" message="Region wise countries saved successfully" callBack={alertOff} />
            )}
            <div className="card" style={{ maxWidth: "950px", minWidth: "350px" }}>
                <h5 className="card-header py-3">
                    <i className="fa fa-folder-open-o" aria-hidden="true"></i> Application wise countries
                </h5>
                <div className="card-body">
                    <div className="ag-theme-alpine">
                        <div style={{ backgroundColor: 'white', marginBottom: "15px" }}>
                            {message.length > 0 ? <div style={{ color: "red", marginBottom: "10px" }}>{message}</div> : ""}
                            <div>
                                <label>Region</label>
                                <Select options={regions} onChange={(e) => loadCountries(e)} />
                            </div>

                            <div style={{ marginTop: "10px" }}>
                                <label>Countries</label>
                                <Select options={countries} isMulti value={appCountries} onChange={(e) => handleChange(e)} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card-footer text-muted">
                    <div style={{ textAlign: "center" }}>
                        <button className="btn btn-secondary" disabled={(!params.id || params.id === 0)} onClick={saveRegionCountries}>Save</button>
                        <button style={{ marginLeft: "5px" }} className="btn btn-secondary" onClick={params.onClose}>Close</button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default RegionCountry;